var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBAppAfterEffects({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2648 0H9.73519C4.35859 0 0 4.35859 0 9.73519V44.2648C0 49.6414 4.35859 54 9.73519 54H44.2648C49.6414 54 54 49.6414 54 44.2648V9.73519C54 4.35859 49.6414 0 44.2648 0Z",
    fill: "#00005B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5068 14.4297H21.4258L30.3061 39.2214H23.0537L21.8325 35.4473H12.5449L11.3237 39.2214H4.36719L13.5068 14.4297ZM19.9082 29.5637L17.207 21.2383L14.5059 29.5637H19.9082Z",
    fill: "#9999FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2642 29.0088C49.2642 29.8967 49.1904 30.8589 49.0791 31.5989H36.9795C37.7192 33.449 39.4956 34.3372 42.2705 34.3372C44.2686 34.3372 46.0078 33.967 47.7471 33.1531L47.8213 38.2964C45.9336 39.2586 43.8984 39.5916 41.2715 39.5916C34.7959 39.5916 30.4668 36.0022 30.4668 29.4897C30.4668 23.5325 34.6113 19.573 40.0874 19.573C45.7119 19.573 49.2642 23.1992 49.2642 29.0088ZM36.7573 27.3806H43.2324C43.085 25.6416 42.0117 24.4204 40.1245 24.4204C38.3115 24.4204 37.1641 25.3826 36.7573 27.3806Z",
    fill: "#9999FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBAppAfterEffects);
export default __webpack_public_path__ + "static/media/B_app_AfterEffects.e5e7b0cfc0abe70a1d1ddb7198e99c9b.svg";
export { ForwardRef as ReactComponent };